import { apiV2Root } from "consts";
import type { Restriction } from "features/restrictions/data/types";
import { useDataQueryParams } from "hooks/useDataQueryParams";

export function useUserRestrictions(userId: number) {
  const data = useDataQueryParams<Restriction[]>(
    `restrictions/user/${userId}/`,
    {},
    apiV2Root,
    !userId,
  );

  const restrictions = data ?? [];
  const active = restrictions.filter((r) => r.isActive);
  const history = restrictions.filter((r) => !r.isActive);

  return { active, history };
}
